<template>
	<div class="NewLists-div">
		<div class="NewLists-top">
			<Navbar></Navbar>
		</div>
    <div class="NewLists-banner">
      <img src="../assets/images/banner2.png" />
    </div>
    <div class="NewLists-content">
      <div class="NewLists-content-div">
        <div class="NewLists-con-tab">
          <div class="NewLists-con-tabtitle">产品中心<span class="toBack" @click="toBack()">返回</span></div>
          <ul class="NewLists-con-tabul">
            <router-link tag="li" v-for="(item, index) in conditionArr[0].data"
                :key="index"
                class="NewLists-con-tabli"
                :to="{path: '/ProductsList', query: {type: index}}">{{item.name}}</router-link>
          </ul>
        </div>
        <div class="NewLists-con-news" v-if="detail">
          <div class="NewLists-con-news1">
            <div class="NewLists-news1-title">
              产品型号：{{$route.query.name}}
            </div>
            <div class="NewLists-news1-con">
              <div class="NewLists-news1-products" @click="picDialogVisible = true">
                <img style="width:140px; height:140px;" :src="detail.pic" />
              </div>
              <div class="NewLists-news1-products-desc">
                <div class="NewLists-news1-products-title">{{detail.title}}</div>
                <div class="NewLists-news1-products-con">{{detail.introduction}}</div>
              </div>
            </div>
          </div>
          <div class="NewLists-con-news2">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="产品详情" name="1">
                <div class="NewLists-news2-con NewLists-news2-con1" v-html="detail.content.replaceAll('/prod-api', '')">
                </div>
              </el-tab-pane>
              <el-tab-pane label="相关资料" name="2">
                <div class="NewLists-news2-con">
                  <Productstable :fileList="fileList"></Productstable>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="NewLists-con-news" v-else>
          <el-empty description="暂无详情"></el-empty>
        </div>
      </div>
    </div>


    <el-dialog
      title="图片"
      :visible.sync="picDialogVisible"
      width="35%"
      :before-close="handleClose">
      <img style="width:100%;" :src="detail.pic" />
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
	</div>
</template>

<script>
import { conditionArr } from "@/common/condition";
	import Navbar from "../components/Navbar.vue";
	import Productstable from "../components/Productstable.vue";
import request from "../util/request";
	export default {
		name: "Products",
		components: {
			Navbar,
      Productstable
		},
		data() {
		  return {

        picDialogVisible: false,
        
        conditionArr,
        activeindex: -1, // 鼠标移入的
        showindex: 0, // 展示的新闻列表
        activeName: "1", // tab值
        newslist:[{ // 新闻列表
          id: 1,
          tab: "标题1",
          list:[{
            id: 11,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          },{
            id: 22,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          }]
        },
        {
          id: 2,
          tab: "标题2",
          list:[{
            id: 11,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          },{
            id: 22,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2021 01-01"
          }]
        },
        {
          id: 3,
          tab: "标题3",
          list:[{
            id: 11,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          },{
            id: 22,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2023 01-01"
          }]
        }],


        detail: null,
        fileList: [],
		  }
		},
    mounted() {
      // console.log(this.$route.query.id)
      this.getDetail()
      this.getFileList()
    },
    methods: {
      toBack() {
        this.$router.go(-1)
      },
      async getDetail() {
          this.detail = await request.get(`/product/detail?productId=${this.$route.query.id}`)
      },
      async getFileList() {
          this.fileList = await request.get(`/product/file?productId=${this.$route.query.id}`)
      },
      showactive(num) {
        this.activeindex = num;
      },
      hideactive() {
        this.activeindex = -1;
      },
      shownewlist(num) {
        this.showindex = num;
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
	}
</script>

<style scoped>
  .toBack {
    color: #4c4c4c;
    margin-left: 10px;
    cursor: pointer;
  }

  .NewLists-banner {
    width: 100%;
    min-width: 1200px;
    height: 350px;
  }
  
  .NewLists-banner img {
    width: 100%;
    height: 100%;
  }
  
  .NewLists-content {
    min-width: 1200px;
    background-color: #f5f5f5;
  }
  
  .NewLists-content-div {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  
  .NewLists-con-tab,
  .NewLists-con-news {
    border-radius: 10px;
    overflow: hidden;
  }
  
  .NewLists-con-tab {
    background-color: #fff;
    margin-right: 10px;
    width: 180px;
    min-height: 250px;
    flex-shrink: 0;
  }
  
  .NewLists-con-tabtitle {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    padding: 10px 15px;
    box-sizing: border-box;
  }
  
  .NewLists-con-tabli {
    color: #787878;
    background-color: #f5f5f5;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    position: relative;
  }
  
  .NewLists-con-tabli-moveactive {
    color: #232CEA;
    background-color: rgba(35, 44, 234, 0.10);
  }
  
  .NewLists-con-tabli-active {
    color: #232CEA;
    font-weight: bold;
  }
  
  .NewLists-con-tabli-active::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 2px;
    height: 100%;
    z-index: 1;
    background: #232cea;
  }
  
  .NewLists-con-news {
    flex-grow: 2;
  }
  
  .NewLists-con-news1,
  .NewLists-con-news2 {
    background-color: #fff;
    border-radius: 10px;
  }
  
  .NewLists-con-news1 {
    margin-bottom: 10px;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .NewLists-news1-title {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
  }
  
  .NewLists-news1-con {
    padding: 20px;
    box-sizing: border-box;
    background-color: #f7f7f7;
    margin-top: 15px;
    display: flex;
  }
  
  .NewLists-news1-products {
    width: 180px;
    height: 180px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    flex-shrink: 0;
    margin-right: 30px;
  }
  
  .NewLists-news1-products img {
    width: 100%;
    height: 100%;
  }
  
  .NewLists-news1-products-title {
    color: #262626;
    border-bottom: 1px solid #d2d2d2;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 15px;
  }
  
  .NewLists-news1-products-con {
    padding-top: 15px;
    color: #262626;
    font-size: 14px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    line-clamp: 6;
    -webkit-box-orient: vertical;
  }
  
  .NewLists-news1-products-desc {
    padding: 20px 0px;
    box-sizing: border-box;
  }
  
  ::v-deep.el-tabs--top .el-tabs__item.is-top {
    padding-left: 20px;
  }
  
  .NewLists-news2-con {
    padding: 20px;
  }
  
  .NewLists-news2-con1 {
    color: #4c4c4c;
    font-size: 14px;
    line-height: 28px;
  }
</style>